import gql from 'graphql-tag';

const getUsersQuery = gql`
  query GetUsers($organisationId: String) {
    getUsers(organisationId: $organisationId) {
      userId
      firstName
      lastName
      imageUrl
    }
  }
`;

const getUsers = (organisationId: string) => ({
  query: getUsersQuery,
  module: 'users',
  ignoreCache: true,
  buildVariables: () => ({
    organisationId
  })
});

export default getUsers;
